module.exports = __webpack_public_path__ + "static/yorkville-education-lp-79e50eb9fbab9dd75c740bbbe33d9b86.png";